import type { PageLoadMetric } from '../metric/page-load-metric';
import type { Metric } from '../metric/metric';
import type { PageSegmentLoadMetric } from '../metric/page-segment-load';

import { concurrent } from './concurrent';
import { custom } from './custom';
import { interaction } from './interaction';
import { pageLoad } from './pageLoad';
import { pageSegmentLoad } from './pageSegmentLoad';
import type {
	CustomPerformanceEventFactoryConfig,
	InteractionPerformanceEventFactoryConfig,
	PageLoadPerformanceEventFactoryConfig,
	PageSegmentLoadPerformanceEventFactoryConfig,
} from './types';

/**
 * @deprecated use ufo: go/ufo
 */
export const metrics: {
	pageLoad: (config: PageLoadPerformanceEventFactoryConfig) => PageLoadMetric;
	pageSegmentLoad: (config: PageSegmentLoadPerformanceEventFactoryConfig) => PageSegmentLoadMetric;
	interaction: (config: InteractionPerformanceEventFactoryConfig) => Metric;
	custom: (config: CustomPerformanceEventFactoryConfig) => Metric;
	concurrent: {
		pageSegmentLoad: (
			config: PageSegmentLoadPerformanceEventFactoryConfig,
		) => (concurrentId: string | number) => Metric;
		interaction: (
			config: InteractionPerformanceEventFactoryConfig,
		) => (concurrentId: string | number) => Metric;
		custom: (
			config: CustomPerformanceEventFactoryConfig,
		) => (concurrentId: string | number) => Metric;
	};
} = {
	pageLoad,
	pageSegmentLoad,
	interaction,
	custom,
	concurrent,
};
